import {
    Alert,
    Button
} from "antd";

export default function AgreementFooter({

                                            status,

                                            onAgreement,

                                            loading
                                        }) {

    if (
        status !==
        "AWAITING_CONFIRMATION"
    ) {

        return null;
    }

    return (

        <Alert

            type="success"

            showIcon

            message="Le vendeur a soumis une offre."

            description={

                <Button

                    type="primary"

                    size="large"

                    loading={loading}

                    onClick={
                        onAgreement
                    }

                    style={{
                        marginTop: 16
                    }}
                >

                    ✅ Bon pour accord

                </Button>
            }
        />
    );
}